const COMPILED_CONSTANTS = {
    "evolveContractIngestionApiGatewayId": "qll68mcfz0",
    "evolveNexusPublicApiGatewayId": "g073ilidze",
    "evolveAppInferenceProfileArn": "arn:aws:bedrock:us-east-1:872515256343:application-inference-profile/560vc7bet9ug",
    "evolveAppInferenceProfile46Arn": "arn:aws:bedrock:us-east-1:872515256343:application-inference-profile/j4aysxewgucw",
    "evolveSettlementApiGatewayId": "yb0chuqzi7",
    "evolveNexusApiGatewayId": "g0t8njsch1",
    "evolveOSApiGatewayId": "qjhatg9480",
    "securityGroupId": "sg-015e6b782a6eb7fbc",
    "evolveUserPoolId": "us-east-1_WUCTj45ot",
    "evolveGuardDutyMalwareAlertTopicArn": "arn:aws:sns:us-east-1:872515256343:guardduty-malware-alerts",
    "evolveUserPoolClientId": "12t88hb7se7u6ldbb7rilve4mr",
    "evolveCognitoDomain": "vbc-872515256343-us-east-1",
    "evolveSecurityGroupId": "sg-015e6b782a6eb7fbc",
    "evolveNascoNexusRedshiftRole": "arn:aws:iam::872515256343:role/nasco-evolve-redshift-role-nexus",
    "evolveRedshiftWorkgroupArn": "arn:aws:redshift-serverless:us-east-1:872515256343:workgroup/b95542a4-ff9a-431e-8d69-231125cbee8c",
    "RedshiftWorkgroupArn": "arn:aws:redshift-serverless:us-east-1:872515256343:workgroup/b95542a4-ff9a-431e-8d69-231125cbee8c",
    "evolveRedshiftSnapshotLambdaRoleArn": "arn:aws:iam::872515256343:role/nasco-evolve-redshift-snapshot-lambda-role",
    "evolvenexusToProcessBucketName": "evolve-nexus-to-process-872515256343-us-east-1",
    "evolvemediaBucketName": "evolve-media-872515256343-us-east-1",
    "evolvesynthDataBucketName": "evolve-synth-data-872515256343-us-east-1",
    "evolveAwsAccountId": "872515256343",
    "evolvenexusFailedProcessingBucketName": "evolve-nexus-failed-processing-872515256343-us-east-1",
    "evolvemigrationBucketName": "evolve-migration-872515256343-us-east-1",
    "evolvereportsBucketName": "evolve-reports-872515256343-us-east-1",
    "evolvedevBucketName": "evolve-dev-872515256343-us-east-1",
    "evolvesettlementArtifactsBucketName": "evolve-settlement-artifacts-872515256343-us-east-1",
    "evolvenexusProcessedBucketName": "evolve-nexus-processed-872515256343-us-east-1",
    "evolvequarantineBucketName": "evolve-quarantine-872515256343-us-east-1",
    "evolvetemporaryBucketName": "evolve-temporary-872515256343-us-east-1",
    "evolveflowArtifactsBucketName": "evolve-flow-artifacts-872515256343-us-east-1",
    "evolvedynamoBucketName": "evolve-dynamo-872515256343-us-east-1",
    "evolvecontractUploadsBucketName": "evolve-contract-uploads-872515256343-us-east-1",
    "evolveexportDynamoBucketName": "evolve-export-dynamo-872515256343-us-east-1",
    "evolvememoriesBucketName": "evolve-memories-872515256343-us-east-1",
    "evolveNexusCloudFrontDistributionArn": "arn:aws:cloudfront::872515256343:distribution/E26BK7FEKBH1OF",
    "evolveNexusCloudFrontDistributionId": "E26BK7FEKBH1OF",
    "evolveNexusFrontendBucket": "evolve-nexus-frontend-872515256343-us-east-1",
    "evolveNexusSubDomain": "vbc.nexus",
    "evolveOSFrontendBucketName": "evolve-os-frontend-872515256343-us-east-1",
    "evolveOSCloudFrontDistributionArn": "arn:aws:cloudfront::872515256343:distribution/E3AC98OHIOOVJF",
    "evolveOSSubDomain": "vbc.os",
    "evolveOSCloudFrontDistributionId": "E3AC98OHIOOVJF",
    "evolveNascoDomain": "vbps.demo-uat.nasco.com",
    "evolveApiProxyUrl": "https://vbc-proxy.vbps.demo-uat.nasco.com",
    "evolveApiCloudFrontDistributionArn": "arn:aws:cloudfront::872515256343:distribution/E13TS70JXYOF1P",
    "signingProfileVersionArn": "arn:aws:signer:us-east-1:872515256343:/signing-profiles/signingProfile_Tmeazze9bYt4/NScjCHsBGZ",
    "custodianRoleName": "nasco-c7n",
    "errorTopicArn": "arn:aws:sns:us-east-1:872515256343:c7n-errors",
    "signingProfileName": "signingProfile_Tmeazze9bYt4",
    "scheduleGroupName": "CloudCustodian",
    "policySGId": "sg-01108f03b41a1c8f7",
    "custodianRoleArn": "arn:aws:iam::872515256343:role/nasco-admin/nasco-c7n",
    "scheduleRoleArn": "arn:aws:iam::872515256343:role/nasco-admin/nasco-c7n-schedule",
    "custodianAdminRoleArn": "arn:aws:iam::872515256343:role/nasco-admin/nasco-c7n-admin",
    "tenableOneRoleArn": "arn:aws:iam::872515256343:role/nasco-admin/nasco-tenable-one",
    "bedrockLogging": "Yes",
    "logicMonitorRoleArn": "arn:aws:iam::872515256343:role/nasco-admin/nasco-logicmonitor",
    "snsKMSKeyAliasName": "alias/nasco/sns",
    "cfLoggingBucketName": "cloudfront-logs-872515256343-us-east-1",
    "s3LoggingBucketName": "s3-access-logs-872515256343-us-east-1",
    "breakGlassRoleArn": "arn:aws:iam::872515256343:role/nasco-admin/nasco-break-glass",
    "permsBoundaryPolicyARN": "arn:aws:iam::872515256343:policy/nasco/builder-permissions-boundary",
    "deploymentBucketName": "deployment-872515256343-us-east-1",
    "opsPermsBoundaryPolicyARN": "arn:aws:iam::872515256343:policy/nasco/ops",
    "BaselineCloudFrontACLARN": "arn:aws:wafv2:us-east-1:872515256343:global/webacl/NASCO-CloudFront-Baseline/808c92de-5f37-4435-a831-1bc2926989cd",
    "TerraformStateBucketName": "tfstate-872515256343-us-east-1",
    "oidcProviderArn": "arn:aws:iam::872515256343:oidc-provider/api.bitbucket.org/2.0/workspaces/nascodevelopment/pipelines-config/identity/oidc",
    "LocalSecurityTopicName": "aws-controltower-SecurityNotifications",
    "LocalSecurityTopic": "arn:aws:sns:us-east-1:872515256343:aws-controltower-SecurityNotifications",
    "BaselineConfigDeliveryChannel": "aws-controltower-BaselineConfigDeliveryChannel",
    "BaselineConfigRecorder": "aws-controltower-BaselineConfigRecorder",
    "BaselineConfigRole": "arn:aws:iam::872515256343:role/aws-controltower-ConfigRecorderRole",
    "env": "dev"
}
export { COMPILED_CONSTANTS }